var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-with-back-btn',{staticClass:"page",attrs:{"title":"Select Customer"}},[_c('SelectCustomer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }